import { useContext, useEffect, useMemo, useRef, useState } from "react";
import UserImg2 from "../../assets/img/bank-icon.svg";
import Rightarrow from "../../assets/img/icome-arrow.svg";
import Backimg from "../../assets/img/skip-arrow.svg";
import SkorDefaultLoader from "../../assets/img/skorDefaultLoader.gif";
import useTranslator from "../../hooks/useTranslator";
import { Form, Modal } from "react-bootstrap";
import { BsBank2 } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../context/auth/AuthContext";
import axiosInstanceInstance from "../../services/authWrapper";
import axiosInstance from "../../services/authWrapper";
import TenantContext from "../../context/tenant/TenantContext";
import CheckIcon from "../../assets/img/checkmark-circle02.svg";
import { sendUniversalMail } from "../../services/sharedService";
import Cancelimg from "../../assets/img/cancel-01.svg";
import ProcessPassedModal from "./ProcessPassedModal";
import { trackClarityEvent } from "../../Utils/clarityReady";
import { toast, haveValue } from "../../helper/common";
import constants from "../../Utils/constants";
import moment from "moment";

const BankModal = ({
  user,
  updateUserProfile,
  isGuarantor,
  loadGuarantorData,
  guarantor_a_id,
  usedFor,
  setBankshow: setBankshowProp,
  loadFullInfo,
  setPaymentScoreLoading,
  reconnectFlow = false,
  getAnalysisDetails,
  setScoreValue,
  originalUser,
  setFinancial_info_errors,
}) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const { loadUser, userType, loadUserTenant, setLoading } =
    useContext(AuthContext);
  const { uploadBankStatement, sendRemoteConnectLink } =
    useContext(TenantContext);
  const [bankShow, setBankShow] = useState(false);
  const [tink_countryCode, setTink_countryCode] = useState("");
  const [countryCodeError, setCountryCodeError] = useState("");
  const queryParameters = new URLSearchParams(window.location.search);
  const error1 = queryParameters.get("error");
  let account_verification_report_id = queryParameters.get(
    "account_verification_report_id"
  );
  let transaction_report_id = queryParameters.get("transaction_report_id");
  const [calculatingScoreLoading, setCalculatingScoreLoading] = useState(false);
  const [uploadStatementLoading, setUploadStatementLoading] = useState(false);
  const [uploadStatementStatus, setUploadStatementStatus] = useState(false);
  const [submitStepLoading, setSubmitStepLoading] = useState(false);
  const [reuploadStatement, setReuploadStatement] = useState(false);
  const [showTickScreen, setShowTickScreen] = useState(false);
  const [showBankAccountConnectedScreen, setShowBankAccountConnectedScreen] =
    useState(false);
  const [doItLaterLoading, setDoItLaterLoading] = useState(false);
  const [sendLinkLoading, setSendLinkLoading] = useState(false);
  const [sendLinkSuccess, setSendLinkSuccess] = useState(false);

  const close = () => {
    if (setBankshowProp) {
      setBankshowProp(false);
    } else {
      setBankShow(false);
    }
  };

  const isExpiredRenewal = useMemo(() => {
    if (!user?.re_new_pending) return false;
    const dateToCheck = haveValue(user?.bankVerificationDate)
      ? user.bankVerificationDate
      : user?.created_at;
    if (!dateToCheck) return false;
    const expiryDate = moment(dateToCheck).add(2, "months");
    return expiryDate.isBefore(moment(), "day");
  }, [user?.re_new_pending, user?.bankVerificationDate, user?.created_at]);

  useEffect(() => {
    if (error1) {
      toast.error(_t("bankDetailsCannotBeFetched"));
    }
    if (account_verification_report_id && transaction_report_id) {
      let userid = user?._id;
      if (!userid) {
        toast.error(_t("userNotAuthorized"));
      } else {
        calculateScore(
          userid,
          account_verification_report_id,
          transaction_report_id
        );
      }
    }
  }, [account_verification_report_id]);

  const calculateScore = async (
    userid,
    accountverificationid,
    transactionreportid
  ) => {
    account_verification_report_id = null;
    transaction_report_id = null;
    await clearPaymentData(userid);
    if (isGuarantor) {
      loadGuarantorData("applyProfile", null, false);
    } else {
      loadUserTenant(localStorage.getItem("usertype"));
    }
    calculatePaymentScore(userid, accountverificationid, transactionreportid);
  };

  const calculatePaymentScore = async (
    userid,
    accountverificationid,
    transactionreportid
  ) => {
    let url = `${process.env.REACT_APP_SERVER_URL}/tenants/calculatescore?tenantid=${userid}&accountverificationid=${accountverificationid}&transactionreportid=${transactionreportid}`;
    if (isGuarantor) {
      url += "&guarantor=true";
    }
    if (isGuarantor) {
      setShowTickScreen(true);
    } else {
      setShowBankAccountConnectedScreen(true);
    }

    setTimeout(async () => {
      if (isGuarantor) {
        sendGuarantorRequest();
      } else {
        handleSubmitStep();
        if (window.location.pathname === "/onboarding") {
          trackClarityEvent("tenant_bank_connect_step_ended");
          setTimeout(() => {
            trackClarityEvent("tenant_guarantor_step_started");
          }, constants.CLARITY_DELAY);
        }
      }
    }, 2000);

    axiosInstanceInstance
      .get(url)
      .then((res) => {
        let serverResponse = res.data;
        if (serverResponse.status !== "success") {
          if (serverResponse.status == "pending") {
          } else {
            trackClarityEvent("tenant_bank_connect_failed");
            toast.error(_t("skorCanNotBeCalculated"));
          }
        }
        if (serverResponse.status === "success") {
          if (isGuarantor) {
            loadGuarantorData("applyProfile", null, false);
          } else {
            trackClarityEvent("tenant_bank_connected");
            loadUser(userType);
          }
        }
        const url = new URL(window.location);
        url.searchParams.delete("account_verification_report_id");
        url.searchParams.delete("transaction_report_id");
        window.history.replaceState(
          {},
          document.title,
          url.pathname + url.search
        );
      })
      .catch(() => {
        setCalculatingScoreLoading(false);
      });
  };

  const clearPaymentData = async (tenantid) => {
    return new Promise((resolve) => {
      let url = `${process.env.REACT_APP_SERVER_URL}/tenants/algoan-info?tenantid=${tenantid}`;
      if (isGuarantor) {
        url += "&guarantor=true";
      }
      axiosInstance
        .delete(url)
        .then((res) => {
          return resolve(true);
        })
        .catch((err) => {
          let err_res = err;
          toast.error(err_res.message);
          return resolve(null);
        });
    });
  };

  const openBankModal = () => {
    setBankShow(true);
  };
  const BankhandleClose = () => {
    close();
  };

  const changeCountryCode = (e) => {
    setTink_countryCode(e.target.value);
  };

  const connectToBank = () => {
    if (!tink_countryCode) {
      setCountryCodeError(_t("pleaseSelectCountryCode"));
      return;
    } else {
      setCountryCodeError("");
    }
    var lang = "en_US";
    if (localStorage.getItem("i18nextLng") == "es") {
      lang = "es_ES";
    }

    let baseUrl = `https://link.tink.com/1.0/reports/create-report?client_id=${process.env.REACT_APP_TINK_CLIENT_ID}&market=${tink_countryCode}&locale=${lang}&report_types=TRANSACTION_REPORT,ACCOUNT_VERIFICATION_REPORT&refreshable_items=IDENTITY_DATA,CHECKING_ACCOUNTS,SAVING_ACCOUNTS,CHECKING_TRANSACTIONS,SAVING_TRANSACTIONS&account_dialog_type=SINGLE`;

    let tinkUrlLiveFront;

    if (usedFor === "popup") {
      // Case 1: Popup + Not Guarantor
      if (!isGuarantor) {
        tinkUrlLiveFront = `${baseUrl}&redirect_uri=https%3A%2F%2F${process.env.REACT_APP_URL_NAME}%2Fhome`;
      }
      // Case 2: Popup + Guarantor
      else {
        tinkUrlLiveFront = `${baseUrl}&redirect_uri=https%3A%2F%2F${process.env.REACT_APP_URL_NAME}%2Fhome?guarantor=${user?._id}`;
      }
    } else {
      // Case 3: Not Popup + Not Guarantor
      if (!isGuarantor) {
        tinkUrlLiveFront = `${baseUrl}&redirect_uri=https%3A%2F%2F${process.env.REACT_APP_URL_NAME}%2Fonboarding`;
      }
      // Case 4: Not Popup + Guarantor
      else {
        tinkUrlLiveFront = `${baseUrl}&redirect_uri=https%3A%2F%2F${process.env.REACT_APP_URL_NAME}%2Fguarantor%2Fonboarding?guarantor_a_id=${guarantor_a_id}`;
      }
    }

    window.open(tinkUrlLiveFront, "_self");
  };

  const handleTempUploadFile = async (e) => {
    const files = e.target.files;
    let file = files[0];
    const formData = new FormData();
    formData.append("file", file);
    formData.append("tenant_id", user?._id);
    try {
      if (usedFor === "popup") {
        await updateUserProfile({
          bank_status: true,
          paymentScores: null,
          financial_info_errors: null,
          role: "tenant",
        });
        setFinancial_info_errors(null);
        setScoreValue(null);
        setPaymentScoreLoading(true);
        await loadFullInfo(false);
        getAnalysisDetails();
      }
      setUploadStatementLoading(true);
      setUploadStatementStatus(true);
      uploadBankStatement(formData);
      setReuploadStatement(true);
      //  loadUserTenant("tenant");
    } catch (err) {
      console.log("Error: ", err);
    } finally {
      setUploadStatementLoading(false);
    }
  };

  const sendGuarantorRequest = () => {
    // Now link will be send directly and the bank connection link will be sent after the guarantor accepts the request.
    sendMail(user?.email, "score");
  };

  const sendMail = (receiverEmail, emailType) => {
    let payload = {
      receiverEmail: receiverEmail,
      senderId: localStorage.getItem("saveduserid"),
      emailType: emailType,
      status: "processing",
    };
    sendUniversalMail(payload)
      .then((res) => {
        toast.success(_t("emailSent"));
      })
      .catch((err) => {
        toast.error(_t("errorSendingMail"), err?.message);
        console.log(err);
      });
  };

  const handleDoItLater = async () => {
    if (doItLaterLoading) {
      return;
    }
    setLoading(true);
    let formData = {};
    if (isGuarantor || user?.gurantor_for?.length > 0) {
      formData = {
        profile_completed: true,
        role: localStorage.getItem("usertype"),
        is_edit: false,
        lang: localStorage.getItem("i18nextLng"),
      };
    } else {
      formData = {
        step: 7,
        role: localStorage.getItem("usertype"),
      };
      trackClarityEvent("tenant_bank_connect_step_skipped");
      setTimeout(() => {
        trackClarityEvent("tenant_guarantor_step_started");
      }, constants.CLARITY_DELAY);
    }

    try {
      setDoItLaterLoading(true);
      await updateUserProfile(formData);

      if (isGuarantor) {
        sendGuarantorRequest();
        navigate(
          `/home${
            originalUser?.gurantor_added_id?.length === 0 ? "?welcome=true" : ""
          }`
        );
      } else if (user?.gurantor_for?.length > 0) {
        navigate(`/home`);
      }
    } catch (err) {
    } finally {
      setLoading(false);
      setDoItLaterLoading(false);
    }
  };

  const handleSubmitStep = async (sendRequest = false) => {
    try {
      setSubmitStepLoading(true);
      let formData = {};
      if (isGuarantor || user?.gurantor_for?.length > 0) {
        formData = {
          profile_completed: true,
          role: "tenant",
          is_edit: false,
        };
      } else {
        formData = {
          step: 7,
          role: localStorage.getItem("usertype"),
        };
      }

      await updateUserProfile(formData);

      if (sendRequest) {
        sendGuarantorRequest();
      }

      if (isGuarantor) {
        navigate(
          `/home${
            originalUser?.gurantor_added_id?.length === 0 ? "?welcome=true" : ""
          }`
        );
      } else if (user?.gurantor_for?.length > 0) {
        navigate(`/home`);
      }
    } catch (err) {
      console.log("Error", err);
    } finally {
      setSubmitStepLoading(false);
    }
  };

  const sendRemoteConnectToBank = async () => {
    setSendLinkLoading(true);

    try {
      const payload = {
        guarantor_id: user?._id,
      };
      const response = await sendRemoteConnectLink(payload);
      if (response?.success) {
        setSendLinkSuccess(true);
      }
    } catch (error) {
      toast.error(_t("errorSendingTinkLink"));
    } finally {
      setSendLinkLoading(false);
      close();
    }
  };

  return (
    <>
      <div
        className={`approvedModal popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen ${
          isGuarantor ? "guarantorBg" : ""
        }`}
        onClick={usedFor === "popup" ? () => close() : null}
      >
        {!bankShow && (
          <div
            className="popup-content2 position-relative popup-content bg-white required-doc-popup"
            style={{ width: isGuarantor ? "55%" : "" }}
            onClick={
              usedFor === "popup" || isGuarantor
                ? (e) => e.stopPropagation()
                : null
            }
          >
            {usedFor === "popup" && (
              <div className="cursor-pointer" onClick={() => close()}>
                <img
                  src={Cancelimg}
                  alt="icon"
                  className="canceicon topRightIcon"
                />
              </div>
            )}

            {isExpiredRenewal &&
            !showBankAccountConnectedScreen &&
            !uploadStatementStatus ? (
              <div className="row relativeposition position-relative">
                <div className="col-12 heading-section">
                  <div className="authenticateid-header authenticateidHeader w-100">
                    <div className="d-flex justify-content-between align-items-center">
                      <h4>{_t("financialCheck", "Financial check")}</h4>
                      <div
                        className="skipbtn cursor-pointer greenHover"
                        onClick={() => handleDoItLater()}
                      >
                        <p>{_t("iWillDoItLater", "I will do it later")}</p>
                        <img src={Backimg} alt="icon" className="canceicon" />
                      </div>
                    </div>
                    <p className="pt-1 text-start">
                      {_t(
                        "oneLastStepToFinishUpdatingYourProfile",
                        "One last step to finish updating your profile."
                      )}
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <div className="row relativeposition position-relative">
                <div className="col-12 d-flex gap-4 align-items-center justify-content-center heading-section guarantorModal">
                  <div className="authenticateid-header authenticateidHeader text-center">
                    <div className="customHeader">
                      <h4>
                        {_t(
                          "updateYourFinancialInformation",
                          "Text used at popup screen to connect bank"
                        )}
                      </h4>
                      <p>
                        {_t(
                          "completeAddingYourBankAccountForBetterExperience",
                          "Text used at popup screen to connect bank"
                        )}
                      </p>
                    </div>
                    {usedFor !== "popup" && (
                      <div
                        className="skipbtn cursor-pointer skipButtonMobile greenHover"
                        onClick={handleDoItLater}
                      >
                        <p>
                          {_t(
                            "skip",
                            "Text used in guarantor screen at onboarding flow"
                          )}
                        </p>
                        <img src={Backimg} alt="icon" className="canceicon" />
                      </div>
                    )}
                  </div>
                </div>
                {usedFor !== "popup" && (
                  <div
                    className="skipbtn cursor-pointer skipButtonDesktop greenHover"
                    onClick={handleDoItLater}
                  >
                    <p>
                      {_t(
                        "iWillDoItLater",
                        "Text used in guarantor screen at onboarding flow"
                      )}
                    </p>
                    <img src={Backimg} alt="icon" className="canceicon" />
                  </div>
                )}
              </div>
            )}
            <div className="dg_paddingdiv">
              <div className="row justify-content-center">
                <div
                  className={`col-12 ${!isGuarantor ? "col-md-6" : "col-md-9"}`}
                >
                  <div
                    className={`dgboxsetup bank-dgboxsetup h-100 ${
                      user?.bank_details && !isExpiredRenewal
                        ? "verifyIncomeCard"
                        : ""
                    }`}
                  >
                    {(reconnectFlow &&
                      !reuploadStatement &&
                      !showBankAccountConnectedScreen) ||
                    (isExpiredRenewal &&
                      !uploadStatementStatus &&
                      !showBankAccountConnectedScreen) ||
                    (!uploadStatementStatus &&
                      !showBankAccountConnectedScreen &&
                      (!user?.bank_details ||
                        !user.bank_details?.userDataByProvider?.length)) ? (
                      <>
                        {isExpiredRenewal ? (
                          <>
                            <div className="aic-status-banner aic-status-banner--warning">
                              <img
                                src="/images/warning-dark-yellow.svg"
                                alt=""
                              />
                              <div className="aic-status-banner-text">
                                <p
                                  className="aic-status-banner-desc"
                                  style={{ color: "#253837", fontSize: "14px" }}
                                >
                                  {_t(
                                    "evenThoughYouConnectedYourBankBeforeThatConnectionHasExpired",
                                    "Even though you connected your bank before, that connection has expired. Choose one of the two options below to update your financial information again."
                                  )}
                                </p>
                              </div>
                            </div>
                            {!calculatingScoreLoading &&
                              !uploadStatementLoading && (
                                <>
                                  <div
                                    className="bank-Statement d-flex custom-gap-2 align-items-center justify-content-between cursor-pointer"
                                    onClick={(e) =>
                                      fileInputRef.current?.click()
                                    }
                                  >
                                    <input
                                      type="file"
                                      ref={fileInputRef}
                                      accept="application/pdf,text/csv"
                                      multiple={false}
                                      id="bankStatementFile"
                                      className="d-none"
                                      onChange={handleTempUploadFile}
                                    />
                                    <div className="w-100">
                                      <h3>
                                        {_t(
                                          "uploadBankStatement",
                                          "Upload bank statement"
                                        )}
                                      </h3>
                                      <h5 className="m-0 pb-0">
                                        {_t(
                                          "uploadYourLast3Months",
                                          "Upload your last 3 months"
                                        )}
                                      </h5>
                                    </div>
                                    <div className="statementicon-div position-relative d-flex align-items-center">
                                      <img
                                        className="arrowimg position-absolute"
                                        src={Rightarrow}
                                        alt="arrow"
                                      />
                                    </div>
                                  </div>
                                  {!isGuarantor && (
                                    <div
                                      className="bank-Statement mb-0 d-flex custom-gap-2 align-items-center justify-content-between cursor-pointer verifyBankDigitally"
                                      onClick={openBankModal}
                                    >
                                      <div className="w-100">
                                        <div className="d-flex align-items-center gap-2">
                                          <h3>
                                            {_t(
                                              "connectBankDigitally",
                                              "Connect bank digitally"
                                            )}
                                          </h3>
                                          <span
                                            style={{
                                              background: "#eaf6df",
                                              color: "#5f9d2d",
                                              padding: "4px 16px",
                                              borderRadius: "999px",
                                              fontSize: "12px",
                                              lineHeight: "16px",
                                              fontWeight: "600",
                                              marginLeft: "4px",
                                            }}
                                          >
                                            {_t("fastest", "Fastest")}
                                          </span>
                                        </div>
                                        <h5 className="m-0 pb-0">
                                          {_t(
                                            "getYourIncomeVerifiedDigitally",
                                            "Get your income verified digitally"
                                          )}
                                        </h5>
                                        <h5 className="countriesText">
                                          {_t("countries")}:{" "}
                                          {[
                                            "belgium",
                                            "germany",
                                            "denmark",
                                            "estonia",
                                            "spain",
                                            "finland",
                                            "france",
                                            "united kingdom",
                                            "italy",
                                            "lithuania",
                                            "latvia",
                                            "netherlands",
                                            "norway",
                                            "poland",
                                            "portugal",
                                            "sweden",
                                          ].map((country, index, arr) => (
                                            <span key={index}>
                                              {_t(country)}
                                              {index !== arr.length - 1 && ", "}
                                            </span>
                                          ))}
                                        </h5>
                                      </div>
                                      <div className="statementicon-div position-relative d-flex align-items-center">
                                        <img
                                          className="arrowimg position-absolute"
                                          src={Rightarrow}
                                          alt="arrow"
                                        />
                                      </div>
                                    </div>
                                  )}
                                  {isGuarantor &&
                                    (sendLinkSuccess ? (
                                      <div className=" d-flex custom-gap-2 align-items-center justify-content-center linkSentSuccessfully">
                                        <img
                                          src="/images/checkIconGreen.svg"
                                          alt="Check Icon"
                                        />
                                        <h3>
                                          {_t(
                                            reconnectFlow
                                              ? "linkSentSuccessfully"
                                              : "linkWillBeSentWhenGuarantorAcceptsRequest"
                                          )}
                                        </h3>
                                      </div>
                                    ) : (
                                      <div
                                        className="bank-Statement bank-Statement-light mb-0 d-flex custom-gap-2 align-items-center justify-content-between cursor-pointer verifyBankDigitally send-guarantor-link send-guarantor-button"
                                        onClick={
                                          sendLinkLoading
                                            ? () => {}
                                            : sendRemoteConnectToBank
                                        }
                                      >
                                        <div className="w-100 d-flex align-items-center justify-content-center">
                                          <h3>
                                            {sendLinkLoading
                                              ? _t("sendingLinkToGuarantor")
                                              : _t(
                                                  reconnectFlow
                                                    ? "sendBankConnectLinkToGuarantor"
                                                    : "sendBankVerificationLinkWhenGuarantorAccepts"
                                                )}
                                          </h3>
                                        </div>
                                        {!sendLinkLoading && (
                                          <div className="statementicon-div position-relative d-flex align-items-center">
                                            <img
                                              className="arrowimg position-absolute"
                                              src="/images/plusIconGreen.svg"
                                              alt="arrow"
                                            />
                                          </div>
                                        )}
                                      </div>
                                    ))}
                                </>
                              )}
                            {calculatingScoreLoading && (
                              <div className="defaultSkorLoaderParent">
                                <img
                                  src={SkorDefaultLoader}
                                  className="defaultSkorLoader"
                                  alt="Example"
                                />
                              </div>
                            )}
                          </>
                        ) : (
                          <>
                            <img
                              className="userimagesetup"
                              src={UserImg2}
                              alt="img"
                            />
                            <h6>
                              {_t(
                                "verifyIncome",
                                "Text used in guarantor screen at onboarding flow"
                              )}
                            </h6>
                            {!calculatingScoreLoading &&
                              !uploadStatementLoading && (
                                <>
                                  <div
                                    className="bank-Statement d-flex custom-gap-2 align-items-center justify-content-between cursor-pointer"
                                    onClick={(e) =>
                                      fileInputRef.current?.click()
                                    }
                                  >
                                    <input
                                      type="file"
                                      ref={fileInputRef}
                                      accept="application/pdf,text/csv"
                                      multiple={false}
                                      id="bankStatementFile"
                                      className="d-none"
                                      onChange={handleTempUploadFile}
                                    />
                                    <div className="w-100">
                                      <h3>
                                        {_t(
                                          "uploadBankStatement",
                                          "Text used in guarantor screen at onboarding flow"
                                        )}
                                      </h3>
                                      <h5 className="m-0 pb-0">
                                        {_t(
                                          "bankStatementWithOnlyEuroAccountsAndShouldNotBeOlderThan3Months",
                                          "Text used in guarantor screen at onboarding flow"
                                        )}
                                      </h5>
                                    </div>
                                    <div className="statementicon-div position-relative d-flex align-items-center">
                                      <img
                                        className="arrowimg position-absolute"
                                        src={Rightarrow}
                                        alt="arrow"
                                      />
                                    </div>
                                  </div>
                                  {!isGuarantor && (
                                    <div
                                      className="bank-Statement mb-0 d-flex custom-gap-2 align-items-center justify-content-between cursor-pointer verifyBankDigitally"
                                      onClick={openBankModal}
                                    >
                                      <div className="w-100">
                                        <h3>
                                          {_t(
                                            "verifyBankDigitally",
                                            "Text used in guarantor screen at onboarding flow"
                                          )}
                                        </h3>
                                        <h5 className="m-0 pb-0">
                                          {_t(
                                            "getYourIncomeVerifiedDigitally",
                                            "Text used in guarantor screen at onboarding flow"
                                          )}
                                        </h5>
                                        <h5 className="countriesText">
                                          {_t("countries")}:{" "}
                                          {[
                                            "belgium",
                                            "germany",
                                            "denmark",
                                            "estonia",
                                            "spain",
                                            "finland",
                                            "france",
                                            "united kingdom",
                                            "italy",
                                            "lithuania",
                                            "latvia",
                                            "netherlands",
                                            "norway",
                                            "poland",
                                            "portugal",
                                            "sweden",
                                          ].map((country, index, arr) => (
                                            <span key={index}>
                                              {_t(country)}
                                              {index !== arr.length - 1 && ", "}
                                            </span>
                                          ))}
                                        </h5>
                                      </div>
                                      <div className="statementicon-div position-relative d-flex align-items-center">
                                        <img
                                          className="arrowimg position-absolute"
                                          src={Rightarrow}
                                          alt="arrow"
                                        />
                                      </div>
                                    </div>
                                  )}
                                  {isGuarantor &&
                                    (sendLinkSuccess ? (
                                      <div className=" d-flex custom-gap-2 align-items-center justify-content-center linkSentSuccessfully">
                                        <img
                                          src="/images/checkIconGreen.svg"
                                          alt="Check Icon"
                                        />
                                        <h3>
                                          {_t(
                                            reconnectFlow
                                              ? "linkSentSuccessfully"
                                              : "linkWillBeSentWhenGuarantorAcceptsRequest"
                                          )}
                                        </h3>
                                      </div>
                                    ) : (
                                      <div
                                        className="bank-Statement bank-Statement-light mb-0 d-flex custom-gap-2 align-items-center justify-content-between cursor-pointer verifyBankDigitally send-guarantor-link send-guarantor-button"
                                        onClick={
                                          sendLinkLoading
                                            ? () => {}
                                            : sendRemoteConnectToBank
                                        }
                                      >
                                        <div className="w-100 d-flex align-items-center justify-content-center">
                                          <h3>
                                            {sendLinkLoading
                                              ? _t("sendingLinkToGuarantor")
                                              : _t(
                                                  reconnectFlow
                                                    ? "sendBankConnectLinkToGuarantor"
                                                    : "sendBankVerificationLinkWhenGuarantorAccepts"
                                                )}
                                          </h3>
                                        </div>
                                        {!sendLinkLoading && (
                                          <div className="statementicon-div position-relative d-flex align-items-center">
                                            <img
                                              className="arrowimg position-absolute"
                                              src="/images/plusIconGreen.svg"
                                              alt="arrow"
                                            />
                                          </div>
                                        )}
                                      </div>
                                    ))}
                                </>
                              )}
                            {calculatingScoreLoading && (
                              <div className="defaultSkorLoaderParent">
                                <img
                                  src={SkorDefaultLoader}
                                  className="defaultSkorLoader"
                                  alt="Example"
                                />
                              </div>
                            )}
                          </>
                        )}
                      </>
                    ) : user?.bank_details?.userDataByProvider?.[0]
                        ?.providerName === "Uploaded from CSV" ||
                      uploadStatementStatus ? (
                      <>
                        <div className="d-flex align-items-center justify-content-between">
                          <div>
                            <img
                              className="userimagesetup"
                              src={UserImg2}
                              alt="img"
                            />
                          </div>
                        </div>
                        <h6>
                          {_t(
                            "verifyIncome",
                            "Text used in guarantor screen at onboarding flow"
                          )}
                        </h6>
                        <div className="bank-Statement d-flex gap-2 align-items-center justify-content-between cursor-pointer">
                          <div className="w-100">
                            <h3>
                              {_t(
                                "uploadBankStatement",
                                "Text used in guarantor screen at onboarding flow"
                              )}
                            </h3>
                            <h5 className="m-0">
                              {_t(
                                "bankStatementWithOnlyEuroAccountsAndShouldNotBeOlderThan3Months",
                                "Text used in guarantor screen at onboarding flow"
                              )}
                            </h5>
                          </div>
                        </div>
                        <button className="bankStatementButton bankAddedButton bottomButton">
                          <img src={CheckIcon} />
                          {_t("bankStatementAdded")}
                        </button>
                      </>
                    ) : (
                      <>
                        <img
                          className="userimagesetup"
                          src={UserImg2}
                          alt="img"
                        />
                        <h6>
                          {_t(
                            "verifyIncome",
                            "Text used in guarantor screen at onboarding flow"
                          )}
                        </h6>
                        <div className="bank-Statement d-flex gap-2 align-items-center justify-content-between cursor-pointer">
                          <div className="w-100">
                            <h3>
                              {_t(
                                "verifyBankDigitally",
                                "Text used in guarantor screen at onboarding flow"
                              )}
                            </h3>
                            <h5 className="m-0">
                              {_t(
                                "getYourIncomeVerifiedDigitally",
                                "Text used in guarantor screen at onboarding flow"
                              )}
                            </h5>
                          </div>
                        </div>
                        <button className="bankStatementButton bankAddedButton">
                          <img src={CheckIcon} />
                          {_t("bankAccountConnected")}
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex guarantorButtonWrapper justify-content-center align-items-center">
              {((user?.bank_details &&
                user?.bank_details?.userDataByProvider?.[0]?.providerName ===
                  "Uploaded from CSV") ||
                uploadStatementStatus ||
                sendLinkSuccess) && (
                <button
                  onClick={(e) => {
                    if (usedFor === "popup") {
                      close();
                    } else {
                      if (isGuarantor) {
                        setShowTickScreen(true);
                      } else {
                        handleSubmitStep();
                      }
                    }
                  }}
                  disabled={submitStepLoading}
                  className="btnNext addGuarantorButton submitButton greenHover"
                >
                  {submitStepLoading ? _t("submitting") : _t("submit")}
                </button>
              )}
            </div>
          </div>
        )}
        <Modal
          show={bankShow}
          onHide={BankhandleClose}
          centered
          className="newmodalui connectbankmodal"
          size="lg"
          onClick={
            usedFor === "popup" || isGuarantor
              ? (e) => e.stopPropagation()
              : null
          }
        >
          <Modal.Body className="p-0">
            <div className="row">
              <div className="col-sm-6 p-2 bankimagediv">
                <p>
                  {_t(
                    "youWillNowBeRedirectedToConnectYourBankAccountThroughOurPartnerTinkPoweredByVisa"
                  )}
                </p>
                <p>
                  {_t(
                    "itsImportantForYouToKnowThatWeDoNotHaveDirectAccessToYourBankLoginDetails"
                  )}
                  {_t(
                    "thisProcessIsDesignedToMaintainYourCredentialsEncriptedFromSkorOrAnyOtherThirdParty"
                  )}
                </p>
                <img src="/images/connect_bank.svg" alt="bank_logo" />
                <p>
                  {_t(
                    "weAssureYouOfTheUtmostPrivacyAndSecurityOfYourFinancialData"
                  )}
                </p>
              </div>
              <div className="col-sm-6 p-2 connectbankdiv">
                <h3 className="position-relative">
                  <img
                    src="/images/arrow-right.svg"
                    className="arrowBack"
                    onClick={BankhandleClose}
                  />
                  {_t("connectBank")}
                </h3>
                <Form className="loginform">
                  <div className="auth-form">
                    <div className="bigform h-auto w-100">
                      <div className="form-grid w-100">
                        <div className="form-group w-100">
                          <label className="">{_t("country")}</label>
                          <select
                            id="employment_status"
                            onChange={changeCountryCode}
                          >
                            <option value="">{_t("selectYourCountry")}</option>
                            <option value="BE">{_t("belgium")}</option>
                            <option value="DE">{_t("germany")}</option>
                            <option value="DK">{_t("denmark")}</option>
                            <option value="EE">{_t("estonia")}</option>
                            <option value="ES">{_t("spain")}</option>
                            <option value="FI">{_t("finland")}</option>
                            <option value="FR">{_t("france")}</option>
                            <option value="GB">{_t("unitedKingdom")}</option>
                            <option value="IT">{_t("italy")}</option>
                            <option value="LT">{_t("lithuania")}</option>
                            <option value="LV">{_t("latvia")}</option>
                            <option value="NL">{_t("netherlands")}</option>
                            <option value="NO">{_t("norway")}</option>
                            <option value="PL">{_t("poland")}</option>
                            <option value="PT">{_t("portugal")}</option>
                            <option value="SE">{_t("sweden")}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="forminput row100 forminput-style">
                      <div
                        className="bankname bankname-style"
                        onClick={connectToBank}
                      >
                        <BsBank2 />
                        {_t("connectBank")}
                      </div>
                      <span className="addRedColor">{countryCodeError}</span>
                    </div>
                  </div>
                </Form>
                <div className="bank-btm">
                  {_t("shouldYouHaveAnyConcernsOrQuestionsPlease")}
                  <a
                    href={undefined}
                    onClick={(e) => navigate("/bank")}
                    className="btnlink"
                  >
                    {_t("readHere")}
                  </a>
                  {_t("orContactUsAt")}
                  <a href="mailTo:info@skortorent.com" className="btnlink">
                    info@skortorent.com.
                  </a>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <ProcessPassedModal
          heading={
            isGuarantor
              ? `${_t("guarantorsOnboradingSuccessful")}`
              : _t("onboardingSuccessful")
          }
          subheading={
            isGuarantor
              ? `${_t(
                  "guarantorsOnboardingHasBeenSuccessfullyCompletedMailhasbeensenton"
                )} ${user?.email}`
              : _t("yourOnboardingHasBeenSuccessfullyCompleted")
          }
          showPopup={showTickScreen}
          buttonText={"goHome"}
          handleClick={() => handleSubmitStep(true)}
        />
      </div>
    </>
  );
};

export default BankModal;
